<template>
  <div class="user-detail">
    <BaseUserProfile
      ref="image__user"
      :user-name="userName"
      :picture="userForum.profile_picture"
    ></BaseUserProfile>

    <div ref="text__user-info" class="text__user-detail">
      <span ref="text__user-fullname" class="text__user-name">{{ userName }}</span>

      <span ref="text__user-label" class="text__user-role">{{ userRole }}</span>
    </div>

    <div v-if="forumDate" ref="text__date" class="text__date text-black-50">
      {{ forumDate }}
    </div>
  </div>
</template>

<script>
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import LearningUnit from '@/models/LearningUnit';

export default {
  components: {
    BaseUserProfile
  },

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    userForum: {
      type: Object,
      required: true
    },

    forumDate: {
      type: String,
      default: null
    }
  },

  computed: {
    userName() {
      return this.userForum ? `${this.userForum.firstname} ${this.userForum.lastname}` : '';
    },

    userRole() {
      const isExpert = this.learningUnit.isEligibleAll(this.userForum.id);

      return isExpert ? 'Expert' : 'Learner';
    }
  }
};
</script>

<style lang="scss" scoped>
.user-detail {
  display: flex;
  flex-direction: row;
  gap: 0 0.5rem;
}

.text__user-detail {
  display: flex;
  flex-direction: column;

  > .text__user-name {
    color: var(--primary);
    font-weight: 600;
    font-size: 1rem;
  }

  > .text__user-role {
    color: var(--dark);
    font-weight: 400;
    font-size: 0.75rem;
    padding-left: 2px;
  }
}

.text__date {
  font-weight: 500;
  font-size: 1rem;
}
</style>
